"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postBuildUnsignedPayloadTransaction = exports.postBuildTransaction = exports.buildUnsignedPayloadTransaction = exports.buildTransaction = void 0;
const tx_1 = require("cosmjs-types/cosmos/staking/v1beta1/tx");
const tx_2 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const signing_1 = require("cosmjs-types/cosmos/tx/signing/v1beta1/signing");
const tx_3 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const cosmos_1 = require("@keplr-wallet/cosmos");
const keys_1 = require("@keplr-wallet/proto-types/cosmos/crypto/secp256k1/keys");
const tx_4 = require("@keplr-wallet/proto-types/cosmos/tx/v1beta1/tx");
const tx_5 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const long_1 = __importDefault(require("long"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const proto_signing_1 = require("@cosmjs/proto-signing");
const Cosmos_1 = require("./api/Cosmos");
const buildTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const aminoMsgs = [];
    const protoMsgs = [];
    switch (transaction.mode) {
        case "send":
            if (transaction.recipient && transaction.amount.gt(0)) {
                const aminoMsg = {
                    type: "cosmos-sdk/MsgSend",
                    value: {
                        from_address: account.freshAddress,
                        to_address: transaction.recipient,
                        amount: [
                            {
                                denom: account.currency.units[1].code,
                                amount: transaction.amount.toString(),
                            },
                        ],
                    },
                };
                aminoMsgs.push(aminoMsg);
                // PROTO MESSAGE
                protoMsgs.push({
                    typeUrl: "/cosmos.bank.v1beta1.MsgSend",
                    value: cosmos_1.cosmos.bank.v1beta1.MsgSend.encode({
                        fromAddress: account.freshAddress,
                        toAddress: transaction.recipient,
                        amount: [
                            {
                                denom: account.currency.units[1].code,
                                amount: transaction.amount.toString(),
                            },
                        ],
                    }).finish(),
                });
            }
            break;
        case "delegate":
            if (transaction.validators && transaction.validators.length > 0) {
                const validator = transaction.validators[0];
                if (validator && validator.address && transaction.amount.gt(0)) {
                    const aminoMsg = {
                        type: "cosmos-sdk/MsgDelegate",
                        value: {
                            delegator_address: account.freshAddress,
                            validator_address: validator.address,
                            amount: {
                                denom: account.currency.units[1].code,
                                amount: transaction.amount.toString(),
                            },
                        },
                    };
                    aminoMsgs.push(aminoMsg);
                    // PROTO MESSAGE
                    protoMsgs.push({
                        typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
                        value: tx_1.MsgDelegate.encode({
                            delegatorAddress: account.freshAddress,
                            validatorAddress: validator.address,
                            amount: {
                                denom: account.currency.units[1].code,
                                amount: transaction.amount.toString(),
                            },
                        }).finish(),
                    });
                }
            }
            break;
        case "redelegate":
            if (transaction.sourceValidator &&
                transaction.validators &&
                transaction.validators.length > 0 &&
                transaction.validators[0].address &&
                transaction.validators[0].amount.gt(0)) {
                const validator = transaction.validators[0];
                const aminoMsg = {
                    type: "cosmos-sdk/MsgBeginRedelegate",
                    value: {
                        delegator_address: account.freshAddress,
                        validator_src_address: transaction.sourceValidator,
                        validator_dst_address: validator.address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: validator.amount.toString(),
                        },
                    },
                };
                aminoMsgs.push(aminoMsg);
                // PROTO MESSAGE
                protoMsgs.push({
                    typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
                    value: tx_1.MsgBeginRedelegate.encode({
                        delegatorAddress: account.freshAddress,
                        validatorSrcAddress: transaction.sourceValidator,
                        validatorDstAddress: validator.address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: validator.amount.toString(),
                        },
                    }).finish(),
                });
            }
            break;
        case "undelegate":
            if (transaction.validators && transaction.validators.length > 0) {
                const validator = transaction.validators[0];
                if (validator && validator.address && validator.amount.gt(0)) {
                    const aminoMsg = {
                        type: "cosmos-sdk/MsgUndelegate",
                        value: {
                            delegator_address: account.freshAddress,
                            validator_address: validator.address,
                            amount: {
                                denom: account.currency.units[1].code,
                                amount: validator.amount.toString(),
                            },
                        },
                    };
                    aminoMsgs.push(aminoMsg);
                    // PROTO MESSAGE
                    protoMsgs.push({
                        typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
                        value: tx_1.MsgUndelegate.encode({
                            delegatorAddress: account.freshAddress,
                            validatorAddress: validator.address,
                            amount: {
                                denom: account.currency.units[1].code,
                                amount: validator.amount.toString(),
                            },
                        }).finish(),
                    });
                }
            }
            break;
        case "claimReward":
            if (transaction.validators &&
                transaction.validators.length > 0 &&
                transaction.validators[0].address) {
                const validator = transaction.validators[0];
                const aminoMsg = {
                    type: "cosmos-sdk/MsgWithdrawDelegationReward",
                    value: {
                        delegator_address: account.freshAddress,
                        validator_address: validator.address,
                    },
                };
                aminoMsgs.push(aminoMsg);
                // PROTO MESSAGE
                protoMsgs.push({
                    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                    value: tx_2.MsgWithdrawDelegatorReward.encode({
                        delegatorAddress: account.freshAddress,
                        validatorAddress: validator.address,
                    }).finish(),
                });
            }
            break;
        case "claimRewardCompound":
            if (transaction.validators &&
                transaction.validators.length > 0 &&
                transaction.validators[0].address &&
                transaction.validators[0].amount.gt(0)) {
                const validator = transaction.validators[0];
                // AMINO MESSAGES
                const aminoWithdrawRewardMsg = {
                    type: "cosmos-sdk/MsgWithdrawDelegationReward",
                    value: {
                        delegator_address: account.freshAddress,
                        validator_address: validator.address,
                    },
                };
                const aminoDelegateMsg = {
                    type: "cosmos-sdk/MsgDelegate",
                    value: {
                        delegator_address: account.freshAddress,
                        validator_address: validator.address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: validator.amount.toString(),
                        },
                    },
                };
                aminoMsgs.push(aminoWithdrawRewardMsg, aminoDelegateMsg);
                // PROTO MESSAGES
                protoMsgs.push({
                    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                    value: tx_2.MsgWithdrawDelegatorReward.encode({
                        delegatorAddress: account.freshAddress,
                        validatorAddress: validator.address,
                    }).finish(),
                });
                protoMsgs.push({
                    typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
                    value: tx_1.MsgDelegate.encode({
                        delegatorAddress: account.freshAddress,
                        validatorAddress: validator.address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: validator.amount.toString(),
                        },
                    }).finish(),
                });
            }
            break;
    }
    return { aminoMsgs, protoMsgs };
});
exports.buildTransaction = buildTransaction;
/* Build transaction with unsigned payload for simulation and gas estimation */
const buildUnsignedPayloadTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const messages = [];
    // Ledger Live is able to build transaction atomically,
    // Take care expected data are complete before push msg.
    // Otherwise, the transaction is silently returned intact.
    let isComplete = true;
    switch (transaction.mode) {
        case "send":
            if (!transaction.recipient || transaction.amount.lte(0)) {
                isComplete = false;
            }
            else {
                messages.push({
                    typeUrl: "/cosmos.bank.v1beta1.MsgSend",
                    value: {
                        fromAddress: account.freshAddress,
                        toAddress: transaction.recipient,
                        amount: [
                            {
                                denom: account.currency.units[1].code,
                                amount: transaction.amount.toString(),
                            },
                        ],
                    },
                });
            }
            break;
        case "delegate":
            if (!transaction.validators || transaction.validators.length < 1) {
                isComplete = false;
            }
            else {
                const validator = transaction.validators[0];
                if (!validator) {
                    isComplete = false;
                    break;
                }
                else if (!validator.address || transaction.amount.lte(0)) {
                    isComplete = false;
                }
                messages.push({
                    typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
                    value: {
                        delegatorAddress: account.freshAddress,
                        validatorAddress: validator.address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: transaction.amount.toString(),
                        },
                    },
                });
            }
            break;
        case "undelegate":
            if (!transaction.validators ||
                transaction.validators.length < 1 ||
                !transaction.validators[0].address ||
                transaction.validators[0].amount.lte(0)) {
                isComplete = false;
            }
            else {
                messages.push({
                    typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
                    value: {
                        delegatorAddress: account.freshAddress,
                        validatorAddress: transaction.validators[0].address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: transaction.validators[0].amount.toString(),
                        },
                    },
                });
            }
            break;
        case "redelegate":
            if (!transaction.sourceValidator ||
                !transaction.validators ||
                transaction.validators.length < 1 ||
                !transaction.validators[0].address ||
                transaction.validators[0].amount.lte(0)) {
                isComplete = false;
            }
            else {
                messages.push({
                    typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
                    value: {
                        validatorSrcAddress: transaction.sourceValidator,
                        delegatorAddress: account.freshAddress,
                        validatorDstAddress: transaction.validators[0].address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: transaction.validators[0].amount.toString(),
                        },
                    },
                });
            }
            break;
        case "claimReward":
            if (!transaction.validators ||
                transaction.validators.length < 1 ||
                !transaction.validators[0].address) {
                isComplete = false;
            }
            else {
                messages.push({
                    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                    value: {
                        delegatorAddress: account.freshAddress,
                        validatorAddress: transaction.validators[0].address,
                    },
                });
            }
            break;
        case "claimRewardCompound":
            if (!transaction.validators ||
                transaction.validators.length < 1 ||
                !transaction.validators[0].address ||
                transaction.validators[0].amount.lte(0)) {
                isComplete = false;
            }
            else {
                messages.push({
                    typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                    value: {
                        delegatorAddress: account.freshAddress,
                        validatorAddress: transaction.validators[0].address,
                    },
                });
                messages.push({
                    typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
                    value: {
                        delegatorAddress: account.freshAddress,
                        validatorAddress: transaction.validators[0].address,
                        amount: {
                            denom: account.currency.units[1].code,
                            amount: transaction.validators[0].amount.toString(),
                        },
                    },
                });
            }
            break;
    }
    if (!isComplete) {
        return [];
    }
    return messages;
});
exports.buildUnsignedPayloadTransaction = buildUnsignedPayloadTransaction;
const postBuildTransaction = (signResponse, protoMsgs) => __awaiter(void 0, void 0, void 0, function* () {
    const signed_tx_bytes = tx_3.TxRaw.encode({
        bodyBytes: tx_5.TxBody.encode(tx_5.TxBody.fromPartial({
            messages: protoMsgs,
            memo: signResponse.signed.memo,
            timeoutHeight: undefined,
            extensionOptions: [],
            nonCriticalExtensionOptions: [],
        })).finish(),
        authInfoBytes: tx_4.AuthInfo.encode({
            signerInfos: [
                {
                    publicKey: {
                        typeUrl: "/cosmos.crypto.secp256k1.PubKey",
                        value: keys_1.PubKey.encode({
                            key: Buffer.from(signResponse.signature.pub_key.value, "base64"),
                        }).finish(),
                    },
                    modeInfo: {
                        single: {
                            mode: signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON,
                        },
                        multi: undefined,
                    },
                    sequence: long_1.default.fromString(signResponse.signed.sequence),
                },
            ],
            fee: tx_4.Fee.fromPartial({
                amount: signResponse.signed.fee.amount
                    ? signResponse.signed.fee.amount
                    : undefined,
                gasLimit: signResponse.signed.fee.gas,
            }),
        }).finish(),
        signatures: [Buffer.from(signResponse.signature.signature, "base64")],
    }).finish();
    return signed_tx_bytes;
});
exports.postBuildTransaction = postBuildTransaction;
const postBuildUnsignedPayloadTransaction = (account, transaction, pubkey, unsignedPayload, signature) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const txBodyFields = {
        typeUrl: "/cosmos.tx.v1beta1.TxBody",
        value: {
            messages: unsignedPayload,
            memo: transaction.memo || "",
        },
    };
    const registry = new proto_signing_1.Registry([
        ["/cosmos.staking.v1beta1.MsgDelegate", tx_1.MsgDelegate],
        ["/cosmos.staking.v1beta1.MsgUndelegate", tx_1.MsgUndelegate],
        ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_1.MsgBeginRedelegate],
        [
            "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            tx_2.MsgWithdrawDelegatorReward,
        ],
    ]);
    const cosmosAPI = new Cosmos_1.CosmosAPI(account.currency.id);
    const { sequence } = yield cosmosAPI.getAccount(account.freshAddress);
    const txBodyBytes = registry.encode(txBodyFields);
    const authInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence }], [
        {
            amount: ((_a = transaction.fees) === null || _a === void 0 ? void 0 : _a.toString()) || new bignumber_js_1.default(2500).toString(),
            denom: account.currency.units[1].code,
        },
    ], ((_b = transaction.gas) === null || _b === void 0 ? void 0 : _b.toNumber()) || new bignumber_js_1.default(250000).toNumber(), signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON);
    const txRaw = tx_3.TxRaw.fromPartial({
        bodyBytes: txBodyBytes,
        authInfoBytes,
        signatures: [signature],
    });
    const tx_bytes = Array.from(Uint8Array.from(tx_3.TxRaw.encode(txRaw).finish()));
    return tx_bytes;
});
exports.postBuildUnsignedPayloadTransaction = postBuildUnsignedPayloadTransaction;
exports.default = exports.buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map